// SL Featured Collection — section-sl-featured-collection.js
(function () {
  // Fisher-Yates shuffle, used only when the section is in "random from
  // collection" mode (data-fc-shuffle="true"). Grid and carousel are
  // shuffled independently since only one of them is ever visible at a
  // given screen width — they don't need to match each other.
  function shuffleChildren(container) {
    if (!container || container.getAttribute('data-fc-shuffle') !== 'true') return;
    var items = Array.prototype.slice.call(container.children);
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }
    items.forEach(function (item) {
      container.appendChild(item);
    });
  }

  function initCarousel(root) {
    var viewport = root.querySelector('.fc-carousel__viewport');
    var track = root.querySelector('[data-fc-track]');
    if (!viewport || !track) return;

    // Shuffle BEFORE cloning, so clones inherit the shuffled order.
    shuffleChildren(track);

    var realSlides = Array.prototype.slice.call(track.children);
    var n = realSlides.length;
    if (n === 0) return;

    var dotsWrap = root.querySelector('[data-fc-dots]');
    var prevBtn = root.querySelector('[data-fc-prev]');
    var nextBtn = root.querySelector('[data-fc-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;

    var slides = realSlides;
    var absoluteIndex = 0; // index into `slides` (may include clones once built)
    var loopEnabled = n > 1;

    if (loopEnabled) {
      // Triple the track: [clones of all] [real slides] [clones of all].
      // This guarantees a neighbour is always available to peek at, no
      // matter which product is centered, and keeps the index math simple
      // — the "real" copy always lives in the middle third.
      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();

      realSlides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.classList.add('fc-clone');
        beforeFrag.appendChild(clone);
      });
      realSlides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.classList.add('fc-clone');
        afterFrag.appendChild(clone);
      });

      track.insertBefore(beforeFrag, track.firstChild);
      track.appendChild(afterFrag);

      slides = Array.prototype.slice.call(track.children);
      absoluteIndex = n; // start on the first slide of the middle (real) block
    }

    // Build position dots for the real slide count only.
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var d = 0; d < n; d++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fc-dot';
        dot.setAttribute('data-index', d);
        dot.setAttribute('aria-label', 'Go to product ' + (d + 1));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function realIndexOf(i) {
      return ((i % n) + n) % n;
    }

    function updateCenterAndDots() {
      var viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
      var closest = 0;
      var closestDist = Infinity;

      slides.forEach(function (slide, i) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var dist = Math.abs(slideCenter - viewportCenter);
        slide.classList.remove('is-center');
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });

      slides[closest].classList.add('is-center');
      absoluteIndex = closest;

      var real = realIndexOf(closest);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === real);
      });
    }

    function scrollToSlide(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      var target = slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2;
      viewport.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
    }

    // After a smooth scroll settles on a clone, silently (no animation)
    // reposition into the equivalent slide in the middle "real" block so
    // the loop never runs out of clones to scroll into.
    var settleTimer = null;
    function handleSettle() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        updateCenterAndDots();
        if (!loopEnabled) return;
        if (absoluteIndex < n || absoluteIndex >= n * 2) {
          var wrapped = n + realIndexOf(absoluteIndex);
          absoluteIndex = wrapped;
          scrollToSlide(wrapped, false);
          updateCenterAndDots();
        }
      }, 120);
    }

    viewport.addEventListener('scroll', handleSettle, { passive: true });

    function goTo(index, smooth) {
      absoluteIndex = index;
      scrollToSlide(index, smooth !== false);
    }

    function next() {
      goTo(absoluteIndex + 1, true);
    }

    function prev() {
      goTo(absoluteIndex - 1, true);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        restartAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        restartAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = loopEnabled ? n + parseInt(dot.getAttribute('data-index'), 10) : parseInt(dot.getAttribute('data-index'), 10);
        goTo(target, true);
        restartAutoplay();
      });
    });

    // The carousel markup exists in the DOM at all screen sizes (CSS just
    // hides it with `display: none` on desktop), but autoplay must never
    // run outside the mobile breakpoint — otherwise it keeps scrolling the
    // hidden carousel in the background, which can make the desktop grid
    // appear to "shuffle" if it ever becomes visible even briefly (resize,
    // zoom, etc). Mirrors the same 749px breakpoint used in the CSS.
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    var timer = null;
    function startAutoplay() {
      if (!autoplay || n < 2 || !mobileQuery.matches) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }
    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('touchstart', stopAutoplay, { passive: true });
    root.addEventListener('touchend', startAutoplay, { passive: true });

    // Stop autoplay immediately when crossing into desktop width, start it
    // again when crossing back into mobile width.
    function handleBreakpointChange() {
      if (mobileQuery.matches) {
        startAutoplay();
      } else {
        stopAutoplay();
      }
    }
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleBreakpointChange);
    } else if (mobileQuery.addListener) {
      // Safari < 14 fallback.
      mobileQuery.addListener(handleBreakpointChange);
    }

    // Initial position (instant, no animation) and keep it correct on
    // resize since slide widths change with viewport width.
    var resizeTimer = null;
    function reposition() {
      scrollToSlide(absoluteIndex, false);
      updateCenterAndDots();
    }
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(reposition, 150);
    });

    // Give the browser a tick to lay out the (now tripled) track before
    // measuring offsets for the initial scroll position.
    setTimeout(reposition, 0);
    startAutoplay();
  }

  function initGrid(root) {
    var grid = root.querySelector('[data-fc-grid]');
    shuffleChildren(grid);
  }

  function initAll() {
    document.querySelectorAll('[data-fc-carousel]').forEach(function (carousel) {
      initGrid(carousel.closest('.fc-container') || document);
      initCarousel(carousel);
    });
  }

  // ---- Second-image hover (desktop, CSS-only via :hover) / hold-to-peek
  // (mobile). Uses event delegation on `document` so it keeps working on
  // the cloned carousel slides created by initCarousel() without needing
  // to be re-bound after cloning.
  (function initImagePeek() {
    var LONG_PRESS_MS = 300;
    var MOVE_THRESHOLD = 10;
    var pressTimer = null;
    var startX = 0;
    var startY = 0;
    var suppressNextClick = false;

    function clearPressTimer() {
      if (pressTimer) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    }

    function endPeek(media) {
      if (media) media.classList.remove('is-peeking');
    }

    document.addEventListener(
      'touchstart',
      function (e) {
        var media = e.target.closest('.fc-card__media[data-has-secondary="true"]');
        if (!media) return;
        var touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        clearPressTimer();
        pressTimer = setTimeout(function () {
          media.classList.add('is-peeking');
          suppressNextClick = true;
        }, LONG_PRESS_MS);
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (e) {
        var media = e.target.closest('.fc-card__media[data-has-secondary="true"]');
        if (!media) return;
        var touch = e.touches[0];
        if (Math.abs(touch.clientX - startX) > MOVE_THRESHOLD || Math.abs(touch.clientY - startY) > MOVE_THRESHOLD) {
          clearPressTimer();
          endPeek(media);
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (e) {
        var media = e.target.closest('.fc-card__media[data-has-secondary="true"]');
        clearPressTimer();
        if (media) endPeek(media);
      },
      { passive: true }
    );

    document.addEventListener(
      'touchcancel',
      function (e) {
        var media = e.target.closest('.fc-card__media[data-has-secondary="true"]');
        clearPressTimer();
        if (media) endPeek(media);
      },
      { passive: true }
    );

    // A long-press ends with a `click` firing right after `touchend` on
    // most browsers — swallow that one click so holding-and-releasing
    // doesn't also navigate to the product page.
    document.addEventListener('click', function (e) {
      if (suppressNextClick && e.target.closest('.fc-card__media[data-has-secondary="true"]')) {
        e.preventDefault();
      }
      suppressNextClick = false;
    });

    // Stop the native "save image" long-press menu on Android Chrome from
    // interrupting the peek.
    document.addEventListener('contextmenu', function (e) {
      if (e.target.closest('.fc-card__media[data-has-secondary="true"]')) {
        e.preventDefault();
      }
    });
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is added/edited live in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var carousel = event.target.querySelector('[data-fc-carousel]');
    if (carousel) {
      initGrid(event.target);
      initCarousel(carousel);
    }
  });
})();